const PROFILE_HISTORY_KEY = 'profile-history';

const getProfileHistory = () => {
  if (window.localStorage && window.localStorage.getItem(PROFILE_HISTORY_KEY)) {
    try {
      return JSON.parse(window.localStorage.getItem(PROFILE_HISTORY_KEY));
    } catch {
      return null;
    }
  }

  return null;
};

export const saveStorageKeys = (callback?: () => void) => {
  // profile history should be stored
  const profileHistory = getProfileHistory();

  if (callback) {
    callback();
  }

  window.localStorage.setItem(PROFILE_HISTORY_KEY, JSON.stringify(profileHistory));
};

export const getLatestArtist = (accountId: number) => {
  const profileHistory = getProfileHistory();

  if (profileHistory) {
    return profileHistory[accountId];
  }

  return null;
};

export const setLatestArtist = (accountId: number, artistId: number) => {
  const profileHistory = getProfileHistory() || {};
  profileHistory[accountId] = artistId;
  window.localStorage.setItem(PROFILE_HISTORY_KEY, JSON.stringify(profileHistory));
};
